import PropTypes from 'prop-types';

export const DEFAULT_TEMPLATE = 'default';
export const LOADING_TEMPLATE = 'loading';
export const NODATA_TEMPLATE = 'no-data';

export const templateArray = [DEFAULT_TEMPLATE, LOADING_TEMPLATE, NODATA_TEMPLATE];

export const userShape = {
	email: PropTypes.string,
	firstName: PropTypes.string,
	lastName: PropTypes.string,
	initials: PropTypes.string,
	isInternal: PropTypes.oneOf([null, true, false])
};

export const sizeArray = ['sm', 'md', 'xl'];

export const getInitial = (string) => (string ? string.charAt(0).toUpperCase() : '');
